import React, { useEffect, useState } from "react";
import { Box, Button, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../../../components/mui/Dialogue/GlobalDialog";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Form, FormikProvider, useFormik } from "formik";
import {
  getAllAssignedKra,
  updateAssignedKra,
} from "../../../../../redux/features/appraisalSlice";

const EditWeightage = ({
  weightage,
  library,
  libraryId,
  userID,
  dispatchData,
}) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading } = useSelector((state) => state.appraisal);

  const validationSchema = Yup.object().shape({
    masterDatas: Yup.array().of(
      Yup.object().shape({
        weightage: Yup.number()
          .min(1, "Minimum 1%")
          .max(100, "Maximum 100%")
          .required("Weightage is required"),
      })
    ),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      userId: userID,
      masterDatas: [
        {
          masterId: libraryId,
          weightage: weightage,
        },
      ],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const finalpayload = {
        ...values,
        type: "kra",
      };
      dispatch(updateAssignedKra(finalpayload)).then((res) => {
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getAllAssignedKra(dispatchData));
          setOpen(false);
          formik.resetForm();
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={"Edit Weightage"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"xs"}
      closeButton={true}
      popupButton={
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => setOpen(true)}
        >
          <Icon icon="mdi:pencil" width={18} height={18} />
        </Button>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <TextField
                    value={library}
                    disabled
                    fullWidth
                    label="KRA"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                  />
                  <TextField
                    name="masterDatas[0].weightage"
                    type="number"
                    size="small"
                    value={formik.values.masterDatas[0].weightage}
                    error={
                      !!formik.errors.masterDatas?.[0]?.weightage &&
                      formik.touched.masterDatas?.[0]?.weightage
                    }
                    helperText={
                      formik.touched.masterDatas?.[0]?.weightage &&
                      formik.errors.masterDatas?.[0]?.weightage
                    }
                    onChange={formik.handleChange}
                    fullWidth
                    label="Weightage"
                    InputLabelProps={{ shrink: true }}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <Button
                      size="small"
                      variant="outlined"
                      color="primary"
                      onClick={() => setOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disabled={loading}
                      size="small"
                      variant="contained"
                      color="secondary"
                      type="submit"
                    >
                      {loading ? "Please wait..." : "Update"}
                    </Button>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default EditWeightage;
